"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsConsumer = exports.ShisellContext = void 0;
var react_1 = require("react");
var analytics_1 = __importDefault(require("./analytics"));
exports.ShisellContext = react_1.createContext({
    get dispatcher() {
        return analytics_1.default.dispatcher;
    },
});
exports.ShisellContext.displayName = 'Analytics';
exports.AnalyticsConsumer = exports.ShisellContext.Consumer;
